
<template>
    <div class="plan-page">
        <div class="add-user-form-profile profile-mobile-scroll-hide">
            <v-row>
                <v-col cols="12" sm="4" class="blk"></v-col>

                <v-col cols="12" sm="4" class="profile-pick b-data">
                    <v-avatar size="150" class="avatar-vv avatar-150">
                        <img :src="src" alt="profile image" />
                    </v-avatar>
                </v-col>

                <v-col cols="12" sm="4" class="blk"></v-col>

                <v-col cols="12" sm="4" class="blk"></v-col>

                <v-col cols="12" sm="4" class="center-icon b-data">
                    <span class="span-icon" @click="capture()">
                        <v-icon class="profile-icon">mdi-camera-enhance</v-icon>
                        <span>Take Photo</span>
                    </span>

                    <span class="span-icon select-file">
                        <input
                            @change="onFileChange"
                            type="file"
                            class="input-img-file"
                            title=" "
                            accept="image/x-png, image/gif, image/jpeg"
                        />

                        <v-icon class="profile-icon">mdi-image-multiple</v-icon>
                        <span>Select From Files</span>
                    </span>
                </v-col>

                <v-col cols="12" sm="4" class="blk"></v-col>

                <v-col cols="12" sm="4" class="blk"></v-col>

                <v-col cols="12" sm="4" class="b-data">
                    <v-text-field
                        v-model="userEmail"
                        label="Email ID"
                        outlined
                        dense
                        hide-details="auto"
                    ></v-text-field>
                    <InputError :data="error.email" />
                </v-col>

                <v-col cols="12" sm="4" class="blk"></v-col>

                <v-col cols="12" sm="4" class="blk"></v-col>

                <v-col cols="12" sm="4" class="b-data">
                    <PhoneNumber
                        :blur="setMobileError"
                        v-model="phone"
                        :presetPhone="getPresetPhone"
                        :code="getCountryCodes"
                        :focus="inputFocused"
                    ></PhoneNumber>
                    <InputError :data="error.mobile" />
                </v-col>

                <v-col cols="12" sm="4" class="blk">
                    <div class="Telegram">
                        <a
                            v-if="user&&(!user.telegram_id) && show()"
                            :href="getTelegramLink(user)"
                            target="_blank"
                        >Verify with Telegram</a>
                    </div>
                </v-col>
                <v-col cols="12" sm="4" class="blk"></v-col>
                
                <v-col v-if="userDetails && (userDetails.role_id == roleIds.ST)" cols="12" sm="4" class="b-data">
                    <v-text-field
                        v-model="userDetails.center_name"
                        label="Center"
                        outlined
                        dense
                        hide-details="auto"
                        disabled
                    ></v-text-field>
                    <InputError />
                </v-col>
                <v-col v-if="userDetails && (userDetails.role_id == roleIds.ST)" cols="12" sm="4" class="blk"></v-col>
                <v-col cols="12" sm="4" class="blk"></v-col>
                <v-col v-if="userDetails && (userDetails.role_id == roleIds.ST)" cols="12" sm="4" class="b-data">
                    <v-text-field
                        v-model="userDetails.batch_name"
                        label="Batch"
                        outlined
                        dense
                        hide-details="auto"
                        disabled
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" class="blk"></v-col>
                <v-col cols="12" sm="4" class="blk"></v-col>


                <v-col cols="12" sm="4" class="rg-center b-data">
                    <v-btn
                        class="right-btn cust-btn"
                        color="primary"
                        @click="ResetPasswordDialog()"
                    >Reset Password</v-btn>

                    <v-btn @click="onDone('form')" class="right-btn cust-btn" color="primary">Done</v-btn>
                </v-col>

                <v-col cols="12" sm="4" class="blk"></v-col>
            </v-row>
        </div>

        <AlertBox
            :width="widthmodal"
            :onClose="onClose"
            :component="cComponent"
            :status="status"
            :data="{img_url:userSelectedFile}"
        />
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import constants from "@/utils/constants.js";

export default {
    name: "PersonalProfile",
    props: ["tab"],
    mounted() {
        this.userDetails = _.cloneDeep(this.user);
        this.userEmail = _.clone(this.userDetails.email);
        this.phone = this.getMobileNumberWithoutCountryCode(this.userDetails.phone);
        this.src =
            this.user.profile_pic_url ||
            require("@/assets/img/default_user.png");
        // this.me();
        if (!this.countryList || this.countryList.length == 0) {
            this.reqGetCountryCodes();
        }
        this.onlineInstitute = (this.user.institute !== constants.ONLINE_INSTITUTE_ID) ? true : false;
    },
    data() {
        return {
            userDetails: null,
            dialog: false,
            userEmail: "",
            phone: {},
            status: false,
            cComponent: "components/coordinator/UploadProfilePic",
            src: require("@/assets/img/default_user.png"),
            blob: null,
            slectedFile: null,
            code: ["+91"],
            widthmodal: null,
            selectedCountryCode: "+91",
            error: {
                email: {
                    type: null,
                    message: null
                },
                mobile: {
                    type: null,
                    message: "Please enter valid mobile number"
                },
            },
            prevIcon: false,
            nextIcon: false,
            tabClicked: false, 
            onlineInstitute: false, 
            right: false,
            vertical: false,
            grow: false,
            icons: false,
            centered: false,
            isInputFocused:false
        };
    },

    methods: {
        ...mapActions({
            updateProfile: "userStore/updateProfile",
            me: "userStore/me",
            getCountryList: "utilStore/getCountryList",
        }),
        reqGetCountryCodes() {
            this.getCountryList({
                orderBy: { field: "dialingcode", order: "ASC" }
            })
                .then(response => {
                    if (response && response.length) {
                    }
                })
                .catch(err => {});
        },
        inputFocused(){
          this.isInputFocused=true;
        },
        onDone(type) {
            if (this.validate()) {
                let formdata = new FormData();

                if (this.blob) {
                    formdata.append(
                        "reqData[profile_pic]",
                        this.blob,
                        this.blob.name
                    );
                }
                if (type == "form") {
                    formdata.append("reqData[email]", this.userEmail);
                    formdata.append(
                        "reqData[phone]",
                        this.getMobileNumberWithCountryCode(
                            this.phone.countryCode,
                            this.phone.number
                        )
                    );
                }
                this.updateProfile(formdata)
                    .then(response => {
                        this.blob = null;
                        this.$toasted.success(`Profile updated successfully`, {
                            icon: "check_circle"
                        });
                    })
                    .catch(err => {});
            }
        },
        setMobileError() {
            this.isInputFocused=false;
            if (
                this.phone &&
                this.phone.number &&
                this.phone.number.length &&
                !this.isValidMobileNumber(this.phone.number)
            ) {
                this.error.mobile.type = "error";
                this.error.mobile.message = "Please enter valid mobile number";
            } else {
                this.error.mobile.type = "null";
            }
        },
        onClose(data) {
            this.status = data.status;
            if (data.data && data.data.base64Image && data.data.camera) {
                this.slectedFile = data.data.base64Image;
                this.UpdateProfileDialog();
            } else if (data.data && data.data.base64Image) {
                this.src = data.data.base64Image;
                this.blob = data.data.blob;
                this.onDone("image");
            }
        },
        UpdateProfileDialog() {
            this.cComponent = "components/coordinator/UploadProfilePic";
            this.widthmodal = "600px";
            this.status = true;
        },
        capture() {
            this.cComponent = "components/Camera";
            this.widthmodal = "600px";
            this.status = true;
            this.$forceUpdate();
        },
        ResetPasswordDialog() {
            this.cComponent = "components/coordinator/ResetPassword";
            this.widthmodal = "400px";
            this.status = true;
        },
        onFileChange(e) {
            const file = e.target.files[0];
            let fileReader = new FileReader();
            this.slectedFile = URL.createObjectURL(file);
            this.UpdateProfileDialog();
            e.target.value = "";
        },
        validate() {
            this.userEmail = this.removeWhiteSpacesFromEmail(this.userEmail);
            let isValid = true;
            this.error.email.type = null;
            let p = this.getMobileNumberWithCountryCode(
                this.phone.countryCode,
                this.phone.number
            );
            if (
                !this.blob &&
                this.user.email === this.userEmail &&
                this.user.phone === p
            ) {
                return false;
            }
            if (!this.userEmail || this.userEmail.trim().length < 1) {
                this.error.email.type = "error";
                this.error.email.message = "Please enter email ID";
                isValid = false;
            } else if (!this.isValidEmail(this.userEmail)) {
                this.error.email.type = "error";
                this.error.email.message =
                    "The email ID entered by you is invalid. Please enter a valid email ID.";
                isValid = false;
            }
            if (
                this.phone &&
                this.phone.number &&
                this.phone.number.length &&
                !this.isValidMobileNumber(this.phone.number)
            ) {
                this.setMobileError();
                isValid = false;
            }
            return isValid;
        },
        show(){
            return !constants.TELEGRAM_SERVICE_HIDE_INSTITUTE_IDS.includes(this.user.institute)
        }
    },
    computed: {
        ...mapState("userStore", ["user"]),
        ...mapState("utilStore", ["countryList"]),
        getCountryCodes() {
            if (this.countryList && this.countryList.length) {
                return this.countryList.map(c => {
                    return "+" + c.dialingcode;
                });
            }
        },
        getPresetPhone() {
            if(this.userDetails && this.userDetails) {
                return this.getMobileNumberWithoutCountryCode(this.userDetails.phone);
            }
        },
        userSelectedFile() {
            return this.slectedFile;
        }
    }
};
</script>